<script setup lang="ts">
defineProps<{
  wrapperClass?: string;
}>();
</script>

<template>
  <div :class="['py-6', wrapperClass]">
    <h3 class="mb-4">
      <slot name="title"></slot>
    </h3>
    <slot name="content"></slot>
  </div>
</template>
